export enum SearchParamsOtherEnum {
    STEP = "step",
}

export enum SearchParamsVacancyEnum {
    SEARCH = "SearchString",
    DIRECTION = "directionId",
    CITY = "City",
    EXPERIENCE = 'JobExperience',
    TAKE = 'Take'
}

export type SearchParamsEnum = SearchParamsOtherEnum & SearchParamsVacancyEnum;
